/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
'use client';

import React from 'react';
import Lottie from 'lottie-react';
import LoadingLottie from '@/lib/Button/assets/loading-lottie.json';

const Button: React.FC<ButtonProps> = ({
  children,
  isLoading,
  disabled,
  loadingText,
  variant = 'primary',
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={disabled || isLoading}
      className={`font-tasa font-semibold py-2.5 px-2 text-lg hover:bg-static_black relative rounded-lg w-full my-3 min-h-10 
    ${isLoading && loadingText && ' text-left'}
    ${variant === 'primary' && 'bg-black-normal text-white-normal'}
    ${variant === 'secondary' && 'bg-surface-grey-subtle text-on-grey-subtle'}
    ${disabled && 'bg-disabled-normal'}
    ${props.className}`}
    >
      {isLoading ? (
        <>
          {loadingText ? <span className="ml-3">{loadingText}</span> : null}
          <Lottie
            className={`absolute top-0 h-full scale-200 ${
              loadingText ? 'right-3' : 'm-auto left-0 right-0'
            }`}
            loop={true}
            animationData={LoadingLottie}
          />
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
